import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap5';
import * as Yup from 'yup';
import { Formik, Form as FormikForm } from 'formik';

import Footer from 'components/Widgets/Profile/FormFooter';
import HorizontalTextField from 'components/new_ui/Form/HorizontalTextField';
import HorizontalSelectField from 'components/new_ui/Form/HorizontalSelectField';
import useTimeZones from 'components/Common/TimeZones/Hooks/useTimeZones';
import useCountries from 'components/Common/Countries/Hooks/useCountries';
import { useContext as useUsersContext } from 'components/Users/Context';
import StateField from 'components/Common/Affiliates/Form/StateField';
import Actions from 'components/Managers/Profile/Actions';

const transformValues = (values) => ({
  ...values,
  city_name: values.city,
  state_name: values.stateName,
  zip_code: values.zipCode,
  time_zone: values.timeZone,
});

export default function Basic({ onCloseClick }) {
  const { dispatch: dispatchUsers, actions: actionsUsers, state: stateUsers } = useUsersContext();

  const manager = stateUsers.user.attributes.specific;

  const formSchema = Yup.object().shape({
    email: Yup.string().required('Work Email is required'),
    timeZone: Yup.string().typeError('Time Zone is required'),
  });

  const { timeZones } = useTimeZones();
  const { countries } = useCountries();

  const onSubmitHundler = (values, { setSubmitting, setErrors }) => {
    Actions.update(
      stateUsers.user.attributes.specific.id,
      transformValues(values),
      false,
      () => {
        setSubmitting(false);
        onCloseClick();
        actionsUsers.load(dispatchUsers);
      },
      (errors) => {
        const newErrors = {};
        errors.errors.forEach((item) => {
          newErrors[item.source.pointer.replace('/data/attributes/', '')] = item.detail;
        });
        setErrors(newErrors);
        setSubmitting(false);
      },
    );
  };

  return (
    <Formik
      validationSchema={formSchema}
      initialValues={{
        phone: manager.phone,
        email: stateUsers.user.attributes.email,
        country: manager.country,
        stateName: manager.state_name,
        city: manager.city_name,
        address: manager.address,
        zipCode: manager.zip_code,
        timeZone: manager.time_zone,
      }}
      onSubmit={onSubmitHundler}
    >
      {({ isSubmitting }) => (
        <FormikForm className="needs-validation" noValidate="">
          <Row>
            <Col>
              <HorizontalSelectField
                name="timeZone"
                label="Time Zone"
                placeholder={timeZones === null ? 'Loading...' : 'Select Time Zone'}
                options={timeZones === null ? [] : timeZones}
                required
              />
            </Col>
          </Row>

          <Row>
            <Col lg={6}>
              <HorizontalTextField name="phone" label="Mobile Phone" />
            </Col>

            <Col lg={6}>
              <HorizontalTextField name="email" type="email" label="Work Email" required />
            </Col>
          </Row>

          <Row>
            <Col lg={6}>
              <HorizontalSelectField
                name="country"
                label="Country"
                placeholder={countries === null ? 'Loading...' : 'Select Country'}
                options={countries === null ? [] : countries}
              />
            </Col>

            <Col lg={6}>
              <StateField />
            </Col>
          </Row>

          <Row>
            <Col lg={6}>
              <HorizontalTextField name="city" label="City" />
            </Col>

            <Col lg={6}>
              <HorizontalTextField name="zipCode" label="Zip Code" />
            </Col>
          </Row>

          <Row>
            <Col>
              <HorizontalTextField as="textarea" name="address" label="Address" />
            </Col>
          </Row>

          <Footer loading={isSubmitting} onCancel={() => onCloseClick()} />
        </FormikForm>
      )}
    </Formik>
  );
}

Basic.propTypes = {
  onCloseClick: PropTypes.func.isRequired,
};
